"use client";

import React from "react";
import QuickContact from "@/components/common/QuickContact";
import AboutBannerMobile from "@/components/pageComponent/about-us/Mobilebanner";
import TalentSetMobile from "@/components/pageComponent/about-us/setUpMobile";
import HeroValuesMobile from "@/components/pageComponent/about-us/heroValuesMobile";
import AboutMilesEducationMobile from "@/components/pageComponent/about-us/milesAboutMobile";
import MilesRevolutionMobile from "@/components/pageComponent/about-us/milesRevoMobile";
import StatsMilesMobile from "@/components/pageComponent/about-us/statMilesMobile";
import TeamSectionMobile from "@/components/pageComponent/about-us/milesTeamMobile";
import EventTicker from "@/components/common/EventTicker";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
// import CallNowButton from "@/components/common/callNowButton";

const MobilePage: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <div className="w-full">
        <EventTicker />
      </div>
      <GlobalHeaderNew />
      <AboutBannerMobile />
      <TalentSetMobile />
      <HeroValuesMobile />
      <AboutMilesEducationMobile />
      <MilesRevolutionMobile />
      <div className="md:flex md:flex-col md:items-center w-full h-auto xl:px-0 md:px-6 lg:!px-6  px-5 relative square_grid_bg">
        <StatsMilesMobile />
      </div>
      <TeamSectionMobile />
      <div className="w-full">
        <GlobalFooter />
      </div>
      <QuickContact />
      {/* <CallNowButton /> */}
    </div>
  );
};

export default MobilePage;
